import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import AdUnit from '@/components/AdUnit.vue';
import { SNIGEL_EXP_COUNTRIES } from '@/helpers/ad/ad-helper';
import TitleDetailSideInfos from '@/pages/titleDetailV1/v1/sidebar/TitleDetailSideInfos.vue';
import TitleDetailQuickActionBarV1 from '@/pages/titleDetailV1/v1/sidebar/TitleDetailQuickActionBarV1.vue';
import TitleDetailPosterWithInfo from '@/pages/titleDetailV1/v1/sidebar/TitleDetailPosterWithInfo.vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { TitleContentType } from '@/interfaces/snowplow/title-context';
import { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import { useMounted, useWindowSize } from '@vueuse/core';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailTitleSidebarV1',
  props: {
    additionalContexts: { default: () => [] },
    title: null,
    titleContentType: { default: undefined },
    influencedSponsoredAd: { default: undefined },
    showPoster: { type: Boolean, default: true },
    showTitleInfo: { type: Boolean, default: true },
    showQuickAction: { type: Boolean, default: true },
    showChartInfo: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { additionalContexts: SnowplowContext[], title: TitleDetail, titleContentType: TitleContentType, influencedSponsoredAd: SponsoredAdFragment | undefined, showPoster: boolean, showTitleInfo: boolean, showQuickAction: boolean, showChartInfo: boolean };



const { width } = useWindowSize();
const mounted = useMounted();
const { isLoggedIn, experimentsLoaded } = storeToRefs(useUserStore());
const { country } = storeToRefs(useLanguageStore());

const streamingChartInfo = computed(() => {
	return props.title?.streamingCharts?.edges?.[0].streamingChartInfo ?? null;
});

const isExperimentsLoadedOrNonSnigel = computed(
	() => experimentsLoaded.value || !SNIGEL_EXP_COUNTRIES.includes(country.value)
);

const showAd = computed(() => mounted.value && width.value > 1050 && isExperimentsLoadedOrNonSnigel.value);

return { __sfc: true,props, width, mounted, isLoggedIn, experimentsLoaded, country, streamingChartInfo, isExperimentsLoadedOrNonSnigel, showAd, AdUnit, TitleDetailSideInfos, TitleDetailQuickActionBarV1, TitleDetailPosterWithInfo }
}

})